var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarV104(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#90DFAA"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M255.2,363.2c-0.4,0-0.8,0.4-1.6,0.4c-0.4,0-0.8-0.4-1.6-0.4H255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M458.4,404c-46,62.8-120.8,104-204.8,104S95.2,467.2,48.8,404c36-38.4,84.8-58.8,125.6-69.2 c-3.6,29.2,11.6,68.4,12,67.2c15.2-35.2,66.8-38.4,66.8-38.4s51.6,2.8,67.2,38.4c0.4,0.8,15.6-38,12-67.2 C373.6,345.2,422.4,365.6,458.4,404z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M316.8,308L316.8,308c0,5.2-3.2,32.8-61.6,55.2H252c-58.4-22.4-61.6-50-61.6-55.2l0,0 c0.4-10.4,2.8-20.8,7.2-30.4c16,18,35.2,30,56,30c20.4,0,40-11.6,56-30C314,287.2,316.8,297.6,316.8,308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M288.4,372.4L275.6,398h-44l-12.8-25.6c17.6-7.6,34.8-8.8,34.8-8.8S271.2,364.8,288.4,372.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M218,505.6c11.6,1.6,23.6,2.4,36,2.4c12,0,24-0.8,36-2.4l-14-107.2h-44L218,505.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M316.8,307.2c0,0,2.8,32-63.2,56.4c0,0,51.6,2.8,67.2,38.4C321.2,403.6,351.2,326,316.8,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M190.4,307.2c-34,18.8-4.4,96-3.6,94.8c15.2-35.2,67.2-38.4,67.2-38.4 C187.6,339.2,190.4,307.2,190.4,307.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9B54C"
    },
    d: "M312.8,285.6c-16.8,18-36.8,29.6-59.2,29.6s-42.4-11.6-59.2-29.6c0.8-2.8,2-5.6,3.2-8 c16,18,35.2,30,56,30s40-11.6,56-30C310.8,280,312,282.8,312.8,285.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD05B"
    },
    d: "M362.8,224.4c-8.4,14-21.2,22.4-30.8,20.8c-19.2,35.6-47.2,62-78.4,62s-59.2-26.8-78.4-62 c-9.6,1.2-22.4-6.8-30.8-20.8c-10-16.4-10.4-34.4-0.8-40.4c2.4-1.2,4.8-2,7.6-1.6c6.4,16.4,15.2,26.4,15.2,26.4 c-9.2-50.8,28.4-56.4,22-105.2c0,0,23.6,52.4,91.2,15.6l-5.2,10c94.4-21.2,62.8,90,62,92.8c10.8-13.6,17.6-27.2,21.6-39.6 c1.6,0,3.6,0.8,4.8,1.6C373.2,189.6,372.8,208,362.8,224.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M308,50.8c7.6-0.8,20,6,20,6c-34-38.8-89.6-14-89.6-14c18.8-16,35.6-14.4,35.6-14.4 c-79.6-12-93.2,35.6-93.2,35.6c-3.6-5.6-3.6-13.6-3.2-17.6C172,56,178,75.2,178,75.2c-5.6-14-25.2-11.6-25.2-11.6 c16.8,2.8,19.6,13.2,19.6,13.2c-42,15.6-34.8,59.2-34.8,59.2l10-12c-12.4,47.6,19.2,84.4,19.2,84.4c-9.2-50.8,28.4-56.4,22-105.2 c0,0,23.6,52.4,91.2,15.6l-5.2,10c95.6-21.6,62,93.2,62,93.2c34-43.2,28.8-87.6,28.8-87.6l4,16C380.4,78.4,308,50.8,308,50.8z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarV104);
export default __webpack_public_path__ + "static/media/avatar-v104.0b5d3e58d88b916b0dea1b13b39fe9a9.svg";
export { ForwardRef as ReactComponent };